import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "imaker-ico-check",
  "use": "imaker-ico-check-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"imaker-ico-check\">\n    <path stroke=\"#008099\" stroke-width=\"2\" fill=\"none\" d=\"m5.967 10.997 3.206 3.371 7.962-8.37\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol